import { IQuestion, IQuetionType } from "../interfaces/Question";

export const questionTypes = ["Text", "Multichoice"];
export const questionFrequencies = ["Daily", "Weekly", "Monthly"];
export const questionsInitial: IQuestion[] = [
  {
    id: "1",
    text: "How do you feel today?",
    type: "Text",
    frequency: "Daily",
  },
  {
    id: "2",
    text: "How do you feel today?",
    type: "Multichoice",
    frequency: "Daily",
    options: [{ id: "1", title: "yes", score: 1 }],
    startDate: new Date(),
  },
];
